import { HttpContextToken, HttpRequest } from '@angular/common/http';

export const HTTP_ERROR_TOAST_REQUEST = new HttpContextToken<HttpRequest<unknown> | null>(() => null);
export const SUPPRESS_HTTP_ERROR_TOAST = new HttpContextToken<boolean>(() => false);
